import { merge } from 'lodash';

const initialState = {
  /* Campos etapa 1 */
  titulo: '',
  obras: '',
  saneamentoVoc: null,
  dataImobilizacaoInicio: null,
  dataImobilizacaoFim: null
};

const state = initialState;

const getters = {};

const actions = {
  setIndicadorPrazos({ commit }, value) {
    commit('SET_INDICADOR_PRAZOS', value);
  },
  clearIndicadorPrazos({ commit }) {
    commit('CLEAR_INDICADOR_PRAZOS', initialState);
  }
};

const mutations = {
  SET_INDICADOR_PRAZOS: (state, value) => (state = merge(state, value)),
  CLEAR_INDICADOR_PRAZOS: (state, value) => {
    state = merge(state, value);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
